<template><div><h1 id="adressimport-in-datenbank-positionen" tabindex="-1"><a class="header-anchor" href="#adressimport-in-datenbank-positionen"><span>Adressimport in Datenbank (Positionen)</span></a></h1>
<p>Adressimport in Datenbank (Positionen) — Definiert ein Datenfeld im Quellfile für den Adressimport</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In den Positionen des Adressimports werden die einzelnen Spalten des Quellfiles definiert, die importiert werden sollen. Neben dem Import einzelner Spalten können Merkmale, Ereignisse und Buchungen erfasst und Daten übersetzt werden.</p>
<p>Pfad: <code v-pre>Datenaustausch → Adressimport in eigene Datenbank</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>von</dt>
<dd>Quelldatei mit fester Datenlänge: Position des ersten Zeichens des Feldes in einer Zeile<br>Quelldatei mit Spalten, getrennt mit Trennzeichen: Position des Feldes in einer Zeile.<br>Datenfelder ohne &quot;von-Wert&quot; gelten generell, für alle Datensätze. So kann z.B. ein Merkmal oder ein Ereignis für alle importierten Datensätze generiert werden, ohne dass im Quellfile entsprechende Einträge vorhanden sein müssen.</dd>
<dt>bis</dt>
<dd>Quelldatei mit fester Datenlänge: Position des letzten Zeichens des Feldes in einer Zeile<br>Quelldatei mit Spalten, getrennt mit Trennzeichen: immer leer.</dd>
<dt>Feld</dt>
<dd>Einzelnes Feld, oder die Kombination der Felder zum Einlesen<br>
<table>
<thead>
<tr>
<th>Feld</th>
<th>Format Quelldatei</th>
<th>Beispiel Parameter</th>
<th>Beispiel Wert/​Codierung</th>
<th>Bemerkung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Anredecode</td>
<td>Geschlechtscode (m,f,&quot;&quot;) oder Anredecode (andere) aus Tabelle</td>
<td></td>
<td>Herr&gt;m,Frau&gt;f,​Familie&gt;a</td>
<td>Import in die Felder Geschlechtscode und Anredecode. Muss immer zusammen mit einem &quot;Sprachcode&quot; importiert werden!</td>
</tr>
<tr>
<td>Branche</td>
<td>Branchencode aus Tabelle</td>
<td></td>
<td>Lebensmittel&gt;LM, Gesundheit&gt;GS</td>
<td>Erfasst ein beliebiges Merkmal mit Werttyp &quot;ohne Wert&quot;.</td>
</tr>
<tr>
<td>Ereignis</td>
<td>Ereignis, Ereignisposition, Ereignisstatus (Typ und Kategorie), Ereignisdatum, Kanal (kommagetrennt)</td>
<td></td>
<td>ABC&gt;2013.Mailings.​Sommer,10,​XU,19.03.2013,Post</td>
<td>Erfasst ein Ereignis mit den definierten Werten oder importiert das Ereignis aus der Importdatei. Das Mapping ist pro Position auf 1 Wert beschränkt (wenn mehrere Werte gemappt werden sollen, muss eine neue Positionszeile erfasst werden). Eine bereits bestehende Ereignisverknüpfung bei der Person wird ignoriert und nochmals erfasst sofern das Ereignisdatum unterschiedlich ist. Es werden gängige Datumsformate unterstützt z.B. 31.01.2018 oder 31/01/2018 oder nach ISO Format 2018-01-31. Kanal kann leer gelassen werden, wenn das Datum leer ist wird das Tagesdatum verwendet.</td>
</tr>
<tr>
<td>Geburtsdatum</td>
<td>2012-02-1302-20132013</td>
<td></td>
<td></td>
<td>Datum/Jahr wird in das Feld &quot;Geburtsdatum&quot; importiert</td>
</tr>
<tr>
<td>Geschlecht</td>
<td>Geschlechtscode (m,f,&quot;&quot;)</td>
<td></td>
<td>Herr&gt;m,Frau&gt;f</td>
<td>Import in das Feld Geschlecht.</td>
</tr>
<tr>
<td>HausNrZusatz</td>
<td>Text</td>
<td></td>
<td></td>
<td>Hausnummerzusatz, wenn dieser im Quellfile in einer sep. Spalte vorliegt. Wird beim Import mit dem Feld &quot;Hausnummer&quot; zusammengeführt und in 1 Feld importiert.</td>
</tr>
<tr>
<td>Hausnummer</td>
<td>Text</td>
<td></td>
<td></td>
<td>Text wird in das Feld &quot;Hausnummer&quot; importiert</td>
</tr>
<tr>
<td>Kontaktperson</td>
<td>Text. Als Delimiter wird nur &quot; &quot; verwendet. Vorname wird gem. Tabelle &quot;TVorname&quot; gesucht, falls es sich nicht um eine Abkürzung handelt. z.B. aus dem Wert &quot;Herr Hans Muster&quot; wird der Vorname &quot;Hans&quot; gem. Vornamentabelle gefunden. Aus dem Wert &quot;Herr Muster H.&quot; wird &quot;H.&quot; automatisch als Vorname übernommen.</td>
<td></td>
<td></td>
<td>wird bei Organisationen in die Felder Vorname/Nachname eingelesen</td>
</tr>
<tr>
<td>Land</td>
<td>ISO-Code des Landes gem. Tabelle, leer = CH</td>
<td></td>
<td></td>
<td>Code wird in das Feld &quot;Land&quot; importiert</td>
</tr>
<tr>
<td>Nachname</td>
<td>Text</td>
<td></td>
<td></td>
<td>Text wird in das Feld &quot;Nachname&quot; importiert</td>
</tr>
<tr>
<td>Nachname/Organisation</td>
<td>Text</td>
<td></td>
<td></td>
<td>je nach Adresstyp, gem. Feld &quot;AdrTyp&quot;, wird es in Feld &quot;Nachname&quot; oder im Feld &quot;Organisation&quot; übernommen</td>
</tr>
<tr>
<td>Namensanfang</td>
<td>Text, Hans Peter #Muster</td>
<td></td>
<td></td>
<td>Delimiter, der Vorname und Nachname trennt, wenn beide in einem Feld geliefert werden (Nachname folgt auf Delimiter-Zeichen)</td>
</tr>
<tr>
<td>Notiz</td>
<td>Text</td>
<td></td>
<td></td>
<td>Text wird in das Feld &quot;Personinfo&quot; importiert</td>
</tr>
<tr>
<td>Organisation</td>
<td>Text</td>
<td></td>
<td></td>
<td>Text wird in das Feld &quot;Organisation&quot; importiert. Dieses Importfeld kann mehrmals verwendet werden (im Quellfile in separaten Spalten), der Inhalt der jeweiligen Spalte wird als eine neue Zeile im Feld &quot;Organisation&quot; erfasst.</td>
</tr>
<tr>
<td>Organisatorische Einheit</td>
<td>Text</td>
<td></td>
<td></td>
<td>Erfasst zu der Person die angegebene organisatorische Einheit</td>
</tr>
<tr>
<td>Ort</td>
<td>Text</td>
<td></td>
<td></td>
<td>Text wird in das Feld &quot;Ort&quot; importiert</td>
</tr>
<tr>
<td>Personen-ID</td>
<td>Zahl</td>
<td></td>
<td></td>
<td>fügt weitere Daten zu dieser Personen-ID hinzu</td>
</tr>
<tr>
<td>Personenmerkmal</td>
<td></td>
<td>Merkmalcode von Merkmalen &quot;ohne Wert&quot; gem. Tabelle</td>
<td>ABCx&gt;ABC</td>
<td>Importiert den Text als Merkmal oder Wert vom Merkmal (nur bei Merkmalen mit Auswahlliste/​Vorgabewerten)</td>
</tr>
<tr>
<td>Personenmerkmal mit Wert</td>
<td>Wert eines Merkmales, z.B. aus Auswahlliste</td>
<td>Funktion</td>
<td></td>
<td>Erfasst ein beliebiges Merkmal. Das Merkmal muss in der Parameterspalte eingetragen sein.</td>
</tr>
<tr>
<td>Personenquelle</td>
<td>Quellencode aus Tabelle</td>
<td></td>
<td>Quelle_1</td>
<td>füllt das Feld mit der Personenquelle, welches nur im Infoteil der Adressmaske angezeigt wird (abhängig von der Parametrisierug des kundenspezifischen Infoframes)</td>
</tr>
<tr>
<td>Personentyp</td>
<td>p = Privatadresse, f = Organisation</td>
<td></td>
<td>privat&gt;p,​Firma&gt;f</td>
<td>legt den Adresstyp der importierten Adresse fest</td>
</tr>
<tr>
<td>PLZ</td>
<td>Text oder Zahl (0000 oder 000000, wenn Ort automatisch gefunden werden soll</td>
<td></td>
<td></td>
<td>Import in Feld Postleitzahl</td>
</tr>
<tr>
<td>PLZ+Ort</td>
<td>PLZ (Text) + Ort (Text)</td>
<td></td>
<td></td>
<td>Postleitzahl mit Ortsnamen</td>
</tr>
<tr>
<td>Postfach</td>
<td>Zahl oder Text &quot;Postfach&quot;</td>
<td></td>
<td></td>
<td>Die Zahl wird in das Feld &quot;Postfach&quot; importiert und das Schalter &quot;Postfach auf &quot;ja&quot; gesetzt. Wenn ein Postfach ohne Postfachnummer importiert werden soll, muss im Im Quellfile der Text &quot;Postfach&quot; eingetragen sein.</td>
</tr>
<tr>
<td>Publikation</td>
<td>beliebig</td>
<td></td>
<td>z.B. ABC&gt;E-News,+ (+ für &quot;hinzufügen&quot; oder – für &quot;entfernen&quot;</td>
<td>Erfasst/entfernt eine Publikation bei der Person.</td>
</tr>
<tr>
<td>Responsbetrag</td>
<td></td>
<td></td>
<td></td>
<td>Betrag, der für eine Buchung eingesetzt wird. Nur verwendbar bei Adressimport mit manueller Zuordnung. Responsdatum, Responsbetrag, Responsereignis und Zahlungskonto müssen vorhanden sein.</td>
</tr>
<tr>
<td>Responsdatum</td>
<td></td>
<td></td>
<td></td>
<td>Valutadatum, das für eine Buchung eingesetzt wird. Nur verwendbar bei Adressimport mit manueller Zuordnung. Responsdatum, Responsbetrag, Responsereignis und Zahlungskonto müssen vorhanden sein.</td>
</tr>
<tr>
<td>Responsereignis</td>
<td>Ereignis-ID und Ereignisposition, durch Komma getrennt: 2019.Mail,EP01</td>
<td></td>
<td></td>
<td>Responsereignis für das Einlesen von Zahlungen. Nur verwendbar bei Adressimport mit manueller Zuordnung. Responsdatum, Responsbetrag, Responsereignis und Zahlungskonto müssen vorhanden sein.</td>
</tr>
<tr>
<td>Responsinfo</td>
<td>beliebig</td>
<td>z.B. &quot;Externe ID&quot;</td>
<td></td>
<td>Der Wert wird in den manuellen Buchungen bei den Buchungen in das Infofeld ergänzt, mit Label = Eintrag in Parameter. Falls schon ein Text im Infofeld vorhanden ist, wird in eine neue Zeile geschrieben. Nur verwendbar bei Adressimport mit manueller Zuordnung.</td>
</tr>
<tr>
<td>Respons-Zahlungsart</td>
<td>beliebig</td>
<td></td>
<td>z.B. VISA&gt;CreditCard</td>
<td>Mapping auf Zahlungsarten, die in der Tabelle &quot;Zahlungsverwendung&quot; eingetragen sind. Der Zahlungskanal wird in die Z-Buchung bei den manuellen Buchungen eingetragen. Nur verwendbar bei Adressimport mit manueller Zuordnung.</td>
</tr>
<tr>
<td>Sprache</td>
<td>Sprachcode aus Tabelle</td>
<td></td>
<td></td>
<td>Code wird in das Feld &quot;Sprache&quot; importiert</td>
</tr>
<tr>
<td>Strasse</td>
<td>Text</td>
<td></td>
<td></td>
<td>Strasse ohne Hausnummer</td>
</tr>
<tr>
<td>Strasse+HNr</td>
<td>Text</td>
<td></td>
<td></td>
<td>Strasse mit Hausnummer in einem Feld (wird beim Import aufgeteilt)</td>
</tr>
<tr>
<td>Telekomm.</td>
<td>abhängig von der Kommunikations­art gem. Parameter</td>
<td>Tel</td>
<td></td>
<td>Telekommunikations-​Eintrag. Bei diesem Feld ist ein spezifizierender Parameter Adresstyp notwendig (z.B. &quot;Tel&quot; oder &quot;EMail&quot;)</td>
</tr>
<tr>
<td>Titel</td>
<td>Titelcode gem. Tabelle</td>
<td></td>
<td>Doktor&gt;Dr,​Dr. med&gt;Dr</td>
<td>Code wird in das Feld &quot;Titel&quot; importiert</td>
</tr>
<tr>
<td>Vorname</td>
<td>Text</td>
<td></td>
<td></td>
<td>Text wird in das Feld &quot;Vorname&quot; importiert</td>
</tr>
<tr>
<td>Vorname+Nachname</td>
<td>Text (1. Vorname, 2. Nachname). Als Delimiter können die Zeichen &quot;*&quot;, &quot;$&quot;, &quot; &quot; oder der Wert vom Feld &quot;Namensanfang&quot; benutzt werden.</td>
<td></td>
<td></td>
<td>Text wird in die Felder &quot;Vorname&quot; und &quot;Nachname&quot; importiert</td>
</tr>
<tr>
<td>Zahlungskonto</td>
<td>z.B. 1010</td>
<td></td>
<td></td>
<td>Zahlungskonto, das für eine Buchung eingesetzt wird. Nur verwendbar bei Adressimport mit manueller Zuordnung. Responsdatum, Responsbetrag, Responsereignis und Zahlungskonto müssen vorhanden sein.</td>
</tr>
<tr>
<td>Zusatz</td>
<td>Text</td>
<td></td>
<td></td>
<td>Text wird in das Feld &quot;Zusatz&quot; (Adresszusatz) importiert. Dieses Importfeld kann mehrmals verwendet werden (im Quellfile in separaten Spalten), der Inhalt der jeweiligen Spalte wird als eine neue Zeile im Feld &quot;Adresszusatz&quot; erfasst.</td>
</tr>
<tr>
<td>Zusatzinfo</td>
<td>Text</td>
<td></td>
<td></td>
<td>Erfasst einen Bemerkungstext zu einem im Parameter definierten Personenquelleneintrag (z.B. zur Erfassung externer Personen-IDs)</td>
</tr>
<tr>
<td>Zweitname</td>
<td>Text</td>
<td></td>
<td></td>
<td>Mädchenname. Wird mit einem Bindestrich (eingefügt von funtrade) mit dem Feld &quot;Nachname&quot; verbunden. Falls im Zweitnamen bereits ein Bindestrich enthalten ist (z.B. -Meier), fügt funtrade keinen zusätzlichen Bindestrich ein.</td>
</tr>
</tbody>
</table>
</dd>
<dt>Parameter</dt>
<dd>Parameter zum Feld</dd>
<dt>Wert/Codierung</dt>
<dd>Wert eines Feldes, (z.B. &quot;t01&quot; für Merkmal) oder Zuordnung der Dateninhalte einzelner Codes, wenn diese von den in <span class="emphasis"><em><span class="application">funtrade</span></em></span> üblichen Werten abweichen. Z.B. kann die Anrede in den angelieferten Daten mit 1 = &quot;Herr&quot; codiert sein, <span class="emphasis"><em><span class="application">funtrade</span></em></span> muss über die Entsprechung 1&gt;m für den Einlesevorgang verfügen. Einzelne Codierungen im gleichen Feld sind mit Komma zu trennen.</dd>
</dl>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.adrimp.html" title="Adressimport in eigene Datenbank / Fremddatenbank">Adressimport in eigene Datenbank / Fremddatenbank</RouteLink></p>
</div></template>


